import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGoogle } from '@fortawesome/free-brands-svg-icons'
import Button from '@material-ui/core/Button'

const useStyles = makeStyles((theme) => ({
    googleButton: {
        backgroundColor: '#497df7',
        color: 'white',
        textTransform: 'none',
        height: '42px',
        '&:hover': {
            backgroundColor: '#497df775',
        },
    },
}))

const GoogleLoginButton = (props) => {
    const { googleLoginUrl, classNameOverride } = props
    const classes = useStyles()

    return (
        <Button
            data-testid="google-login-button"
            className={`${classes.googleButton} ${classNameOverride}`}
            fullWidth
            size="large"
            href={googleLoginUrl}
            rel="nofollow"
            startIcon={<FontAwesomeIcon icon={faGoogle} color={'white'} />}
        >
            Log in with Google
        </Button>
    )
}

export default GoogleLoginButton

GoogleLoginButton.propTypes = {
    googleLoginUrl: PropTypes.string.isRequired,
    classNameOverride: PropTypes.string,
}
